import React from 'react';
import { FieldArray } from 'formik';
import RuleRow from './RuleRow';
import OrDivider from './OrDivider';
import AddRuleButton from './AddRuleButton';
import * as audienceHelpers from 'helpers/audiencesHelpers';

const emptyRule = {
  id: null,
  name: 'Custom Key',
  key: '',
  kv_relational_op: 'eq',
  sort: null,
  value: '',
  value_type: 'str',
};

const RuleSetCard = ({
  type,
  ruleSet,
  setIndex,
  group,
  form,
  initialForm,
  setInitialForm,
  onRemoveSet,
  canRemove,
  isReadOnly,
  isSubmitting,
}) => {
  const isInclude = type === 'include';
  const badgeText = isInclude ? 'Include Set' : 'Exclude Set';

  const addRule = () => {
    const newRule = { ...emptyRule };
    const updatedGroup = [...initialForm[group]];
    updatedGroup[setIndex] = {
      ...updatedGroup[setIndex],
      rules: [...updatedGroup[setIndex].rules, newRule],
    };
    setInitialForm({
      ...initialForm,
      [group]: updatedGroup,
    });
  };

  const removeRule = (ruleIndex) => {
    const { newForm } = audienceHelpers.removeParam({
      initialForm,
      ruleSetGroup: form.values[group],
      ruleSetIndex: setIndex,
      ruleIndex,
      group,
    });
    setInitialForm(newForm);
  };

  return (
    <div className="aud-v2-card-wrapper">
      <div className={`aud-v2-card aud-v2-card--${type}`}>
        <div className="aud-v2-card__rules">
        <FieldArray name={`${group}[${setIndex}].rules`}>
          {(arrayHelpers) => (
            <>
              {ruleSet.rules.map((rule, ruleIndex) => (
                <React.Fragment key={ruleIndex}>
                  {ruleIndex > 0 && <OrDivider />}
                  <RuleRow
                    rule={rule}
                    ruleIndex={ruleIndex}
                    setIndex={setIndex}
                    group={group}
                    fieldName={`${group}[${setIndex}].rules[${ruleIndex}]`}
                    form={form}
                    onRemove={() => removeRule(ruleIndex)}
                    canRemove={form.values[group][setIndex].rules.length > 1}
                    isReadOnly={isReadOnly}
                    isSubmitting={isSubmitting}
                  />
                </React.Fragment>
              ))}
              <AddRuleButton
                onClick={addRule}
                disabled={isReadOnly || isSubmitting}
              />
            </>
          )}
        </FieldArray>
        </div>
      </div>
      {canRemove && !isReadOnly && (
        <button
          type="button"
          className="aud-v2-card-wrapper__delete"
          onClick={onRemoveSet}
          disabled={isSubmitting}
        >
          <span className="material-icons">delete_outline</span>
        </button>
      )}
    </div>
  );
};

export default RuleSetCard;
